<template>
    <StudentSidebarComponent v-if="!hideSidebar" />
    <v-main style="min-height: 300px">
        <v-container class="sm:px-0 md:px-12 pb-12" fluid>
            <RouterView />
        </v-container>
    </v-main>
</template>

<script lang="ts" setup>
import StudentSidebarComponent from '@/components/layout/StudentSidebarComponent.vue'
import { useRoute } from 'vue-router'
import { computed } from 'vue'

const route = useRoute()
const hideSidebar = computed(() => route.path.startsWith('/student/solve-exam'))
</script>